<template>
  <BaseModal :width="420" title="添加 / 修改 子相册" v-model="show">
    <FormModel :action="submit" :label-col="{span:6}" :model="form.info"
               :rules="rules" :wrapper-col="{span:18}" v-on="$listeners">
      <a-form-model-item label="子相册名称" prop="name">
        <a-input @keydown.stop placeholder="请输入子相册名称" v-model="form.info.name"/>
      </a-form-model-item>
    </FormModel>
  </BaseModal>
</template>

<script>
import func from "../../../../../utils/func";
import cache from "../../../../../utils/cache";
import FormModel from "../../../../../comps/FormModel";
import BaseModal from "../../../../../comps/BaseModal";

export default {
  name: "FolderForm",
  props: {album: Object},
  components: {BaseModal, FormModel},
  data() {
    return {
      show: false,
      form: {id: "", info: {name: "", sort_idx: 0}},
      rules: {
        name: {required: true, message: "子相册名称不能为空"},
        sort_idx: {required: true, message: "请输入大于0的数值"},
      }
    }
  },
  methods: {
    create(index) {
      this.show = true;
      this.form = {id: "", info: {name: "", sort_idx: index}};
    },
    update(folder) {
      this.show = true;
      this.form = func.copyObject(folder);
    },
    submit() {
      let promise = this.form.id === ""
          ? cache.v1.album.folder.create(this.album.id, this.form.info)
          : cache.v1.album.folder.update(this.album.id, this.form.id, this.form.info);
      return promise.then(() => this.show = false);
    }
  }
}
</script>
